import { Field } from "react-final-form-html5-validation";
import React from "react";

const FieldAdapter = (props) => <Field parse={(value) => value} {...props} />;

export default FieldAdapter;
